var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.connected)?_c('dataHomeMenu',{on:{"logout":_vm.logout}}):_vm._e(),(!_vm.connected)?_c('login',{on:{"logged":_vm.successConnected}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }